// Types
import { ActivityType } from '@shared/types';

// Activity labels for timeline events
export const ACTIVITY_LABELS = {
  // Project Activities
  [ActivityType.PROJECT_COMPLETE]: 'The project is completed',
  [ActivityType.PROJECT_GO_LIVE]: 'The project has gone live',
  [ActivityType.PROJECT_RESUME]: 'The project has been resumed',
  [ActivityType.PROJECT_PAUSE]: 'The project has been paused',
  [ActivityType.PROJECT_RELEASE]: 'The project has been released',
  [ActivityType.PROJECT_KICK_OFF]: 'The project has been kicked off',
  [ActivityType.PROJECT_CREATE]: 'The project has been initialized',
  [ActivityType.PROJECT_ARCHIVE]: 'The project has been archived',
  [ActivityType.PROJECT_UNARCHIVE]: 'The project has been unarchived',
  [ActivityType.PROJECT_SCHEDULE_ACTIVITY]: 'The project has been scheduled',

  // Employee Activities
  [ActivityType.PROJECT_MEMBER_ROLE_CHANGE]: 'Role changed',
  [ActivityType.PROJECT_MEMBER_JOIN]: 'Joined project',
  [ActivityType.PROJECT_MEMBER_LEAVE]: 'Left project',
  [ActivityType.PROJECT_MEMBER_RESUME]: 'Resumed in project',

  [ActivityType.TRAINING_CREATE]: 'Created training',
  [ActivityType.TRAINING_START]: 'Started training',
  [ActivityType.TRAINING_COMPLETE]: 'Completed training',
  [ActivityType.TRAINING_PAUSE]: 'Training pending',
  [ActivityType.TRAINING_RESUME]: 'Resumed training',
  [ActivityType.TRAINING_ARCHIVE]: 'Archived training',
  [ActivityType.TRAINING_UNARCHIVE]: 'Unarchived training',
  [ActivityType.TRAINING_FEEDBACK_RECEIVED]: 'Received feedback',
  [ActivityType.TRAINING_FEEDBACK_PRESENTATION]:
    'Received feedback for presentation',
  [ActivityType.TICKET_REALLOCATION]: 'Requested reallocation',
  [ActivityType.TICKET_ROOM_BOOKING]: 'Requested room booking',
  [ActivityType.TICKET_TIME_OFF]: 'Requested time off',
  [ActivityType.TICKET_ON_BEHALF_TIME_OFF]: 'Requested time off on behalf',
  [ActivityType.TICKET_MAINTENANCE]: 'Requested maintenance',
  [ActivityType.TICKET_LUNCH_REGISTRATION]: 'Requested lunch registration',
  [ActivityType.TICKET_ON_BEHALF_LUNCH_REGISTRATION]:
    'Requested lunch registration on behalf',

  // User relationship activities
  [ActivityType.EMPLOYEE_ASSIGN_MENTOR]: 'Assigned mentor',
  [ActivityType.EMPLOYEE_ASSIGN_MENTEE]: 'Assigned mentee',
  [ActivityType.EMPLOYEE_UNASSIGN_MENTOR]: 'Unassigned mentor',
  [ActivityType.EMPLOYEE_UNASSIGN_MENTEE]: 'Unassigned mentee',
  [ActivityType.TRAINING_ASSIGN_SUPPORTER]: 'Assigned supporter',
  [ActivityType.TRAINING_ASSIGN_TRAINEE]: 'Assigned supporter',
} as const;

// Member action labels for timeline events
export const MEMBER_ACTION_LABELS = {
  [ActivityType.PROJECT_MEMBER_JOIN]: 'joined',
  [ActivityType.PROJECT_MEMBER_LEAVE]: 'left',
  [ActivityType.PROJECT_MEMBER_REMOVE]: 'removed',
  [ActivityType.PROJECT_MEMBER_ROLE_CHANGE]: 'role changed',
  [ActivityType.PROJECT_MEMBER_RESUME]: 'resumed',
} as const;

// Activity types that should not show timeline descriptions
export const EXCLUDED_DESCRIPTION_TYPES: ActivityType[] = [
  // Project member activities
  ActivityType.PROJECT_MEMBER_JOIN,
  ActivityType.PROJECT_MEMBER_LEAVE,
  ActivityType.PROJECT_MEMBER_REMOVE,
  ActivityType.PROJECT_MEMBER_ROLE_CHANGE,
  ActivityType.PROJECT_MEMBER_RESUME,

  // Employee activities
  ActivityType.TRAINING_CREATE,
  ActivityType.TRAINING_START,
  ActivityType.TRAINING_COMPLETE,
  ActivityType.TRAINING_PAUSE,
  ActivityType.TRAINING_RESUME,
  ActivityType.TRAINING_ARCHIVE,
  ActivityType.TRAINING_UNARCHIVE,
  ActivityType.TRAINING_FEEDBACK_RECEIVED,
  ActivityType.TRAINING_FEEDBACK_PRESENTATION,
  ActivityType.TICKET_REALLOCATION,
  ActivityType.TICKET_ROOM_BOOKING,
  ActivityType.TICKET_TIME_OFF,
  ActivityType.TICKET_ON_BEHALF_TIME_OFF,
  ActivityType.TICKET_MAINTENANCE,
  ActivityType.TICKET_LUNCH_REGISTRATION,
  ActivityType.TICKET_ON_BEHALF_LUNCH_REGISTRATION,

  // User relationship activities
  ActivityType.EMPLOYEE_ASSIGN_MENTOR,
  ActivityType.EMPLOYEE_ASSIGN_MENTEE,
  ActivityType.EMPLOYEE_UNASSIGN_MENTOR,
  ActivityType.EMPLOYEE_UNASSIGN_MENTEE,
  ActivityType.TRAINING_ASSIGN_SUPPORTER,
  ActivityType.TRAINING_ASSIGN_TRAINEE,
];

// Activity types that should not trigger callbacks
export const EXCLUDED_CALLBACK_TYPES = new Set([ActivityType.PROJECT_CREATE]);

export enum ActivityGroup {
  RESUME = 'resume',
  USER = 'user',
  PROJECT = 'project',
  TICKET = 'ticket',
}
